import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';
import { BotCategoryEnum } from '@/utils/BotCategoryEnum';

interface ChatBotCardProps {
  type: BotCategoryEnum;
  title?: string;
  selected: BotCategoryEnum;
  badge?: string;
  description?: string;
  subDescription?: string;
  onClick: (type: BotCategoryEnum) => void;
}

const ChatBotCard: React.FC<ChatBotCardProps> = ({ type, title, badge, description, subDescription, onClick, selected }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => {
        onClick(type);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(type);
        }
      }}
      className={`tw-cursor-pointer lg:tw-w-[300px] tw-w-full  tw-flex tw-flex-col gap-1 tw-border tw-border-solid tw-rounded-2xl tw-p-3 tw-bg-white hover:tw-border-blue-600 ${
        selected == type ? 'tw-border-blue-600 tw-border-[5px]' : 'tw-border-gray-200'
      }`}
    >
      <div>
        <span
          className={`${
            type == BotCategoryEnum.AI_BASED_CHATBOT ? 'tw-bg-emerald-100 tw-text-black' : 'tw-bg-blue-600 tw-text-white'
          }  tw-rounded-2xl tw-py-1 tw-px-2 tw-text-xs tw-font-['Lexend']`}
        >
          {badge}
        </span>
      </div>
      <div>
        <h2 className="tw-text-xl tw-font-['Lexend']">{title}</h2>
      </div>
      <div className="tw-flex tw-items-start tw-flex-col">
        <span className="tw-font-['Lexend'] tw-text-sm tw-font-semibold">{description}</span>
        <span className="tw-font-['Lexend'] tw-text-sm">{subDescription}</span>
      </div>
    </div>
  );
};

export default WrappedErrorBoundary(ChatBotCard);
